export *                     from './device-group-info.component';

export {
    DeviceGroup,
    DeviceGroupDeviceWrapper
}                            from '@Common/Elements/DeviceGroup/';